// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum STORE_ITEM_TYPE {
    webBook = 'web-book',
    webBookDayPass = 'web-day-pass',
    webBookWeekPass = 'web-week-pass',
    webBookChapterOne = 'web-chapter-1',
    webBookChapterTwo = 'web-chapter-2',
    webBookChapterThree = 'web-chapter-3',
    webBookChapterFour = 'web-chapter-4',
    webBookChapterFive = 'web-chapter-5',
    webBookChapterSix = 'web-chapter-6',
    webBookChapterSeven = 'web-chapter-7',
    webBookChapterEight = 'web-chapter-8',
    webBookChapterNine = 'web-chapter-9',
    webBookChapterTen = 'web-chapter-10',
    webBookChapterEleven = 'web-chapter-11',
    webBookChapterTwelve = 'web-chapter-12',
    webBookChapterThirteen = 'web-chapter-13',
    webBookChapterFourteen = 'web-chapter-14',
    webBookChapterFifteen = 'web-chapter-15',
    webBookChapterSixteen = 'web-chapter-16',
    webBookChapterSeventeen = 'web-chapter-17',
    webBookChapterEighteen = 'web-chapter-18',
    webBookChapterNineteen = 'web-chapter-19',
    webBookAppendixA = 'web-appendix-a',
    digitalBookPreorder = 'digital-book-preorder',
    digitalBook = 'digital-book',
    audioBook = 'audio-book',
    physicalBookPreorder = 'physical-book-preorder',
    physicalBook = 'physical-book',
}
